import { render } from "./InputModal.vue?vue&type=template&id=0d96cfe0&ts=true"
import script from "./InputModal.vue?vue&type=script&lang=ts"
export * from "./InputModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__